module.exports = __webpack_public_path__ + "img/pic_fence_box.63ed0415.png";